import { captureException } from '@sentry/nextjs'

import { employeeSanity } from '~/shared/sanity/employee'
import { Employee, EmployeeCategory } from '~/employee/types/employee.types'
import { AppLanguage } from '~/types/locale'

export const getAllEmployeeData = async (language: AppLanguage): Promise<Employee[] | null> => {
  try {
    const employees = await employeeSanity.getAllEmployeeData({ language })

    return employees
  } catch (error) {
    captureException(error, { tags: { feature: 'employee', action: 'sanity-fetch' } })

    return null
  }
}

export const getEmployeeCategories = async (language: AppLanguage): Promise<EmployeeCategory[] | null> => {
  try {
    const categories = await employeeSanity.getEmployeeCategories({ language })

    return categories
  } catch (error) {
    captureException(error, { tags: { feature: 'employee', action: 'sanity-fetch' } })

    return null
  }
}
